import { render, staticRenderFns } from "./AppointmentFormNCP.vue?vue&type=template&id=8b4445f6&scoped=true"
import script from "./AppointmentFormNCP.vue?vue&type=script&lang=js"
export * from "./AppointmentFormNCP.vue?vue&type=script&lang=js"
import style0 from "./AppointmentFormNCP.vue?vue&type=style&index=0&id=8b4445f6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4445f6",
  null
  
)

export default component.exports